import React from "react";
import { useParams } from "react-router-dom";
import ScheduleCalenderContainer from "../../../containers/ScheduleServiceContainer/ScheduleCalenderContainer/ScheduleCalenderContainer";

const ScheduleServiceCalebderPage = () => {
  const route: {
    careGiverId: string;
    careTakerId: string;
  } = useParams();
  return <ScheduleCalenderContainer params={route} />;
};

export default ScheduleServiceCalebderPage;
